/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportVariantsCatalogMutationRequest,
  ExportVariantsCatalogMutationResponse,
  ExportVariantsCatalog400,
  ExportVariantsCatalog500,
} from '../types/ExportVariantsCatalog'

function getExportVariantsCatalogUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/products/catalog/variants/export/` as const,
  }
  return res
}

/**
 * @description Handle export request via POST.
 * @summary Export variants catalog to CSV or XLSX
 * {@link /api/v1/products/catalog/variants/export/}
 */
export async function exportVariantsCatalog(
  data: ExportVariantsCatalogMutationRequest,
  config: Partial<RequestConfig<ExportVariantsCatalogMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportVariantsCatalogMutationResponse,
    ResponseErrorConfig<ExportVariantsCatalog400 | ExportVariantsCatalog500>,
    ExportVariantsCatalogMutationRequest
  >({
    method: 'POST',
    url: getExportVariantsCatalogUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
